<div class="modal-body" id="modal-body">
  <app-vrf-wan-ip-groups-list (rowClick)="modal.close($event)" [disableUrlUpdate]="true"
                              [disabledButtons]="disabledButtons" [disabledColumns]="disabledColumns"
                              [filters]="filters" [disableRouterLink]="true">
  </app-vrf-wan-ip-groups-list>
</div>